import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import './styles.css';
import ambulancia from '../../../../assets/images/ambulancia.webp';
import asistencia from '../../../../assets/images/asistencia.webp';
import cerrajeria from '../../../../assets/images/cerrajeria.webp';
import corriente from '../../../../assets/images/corriente.webp';
import gasolina from '../../../../assets/images/gasolina.webp';
import grua from '../../../../assets/images/grua.webp';
import legal from '../../../../assets/images/legal.webp';
import llanta from '../../../../assets/images/llanta.webp';

const cards = [
  {
    title: 'Asistencia en viajes',
    description:
      'Si vas de viaje en tu vehículo y tienes algún incidente y ya no puedes manejar de regreso, te apoyamos con hospedaje, gastos de transporte y asistencia médica.',
    image: asistencia,
  },
  {
    title: 'Cerrajería para tu vehículo',
    description:
      '¿Dejaste las llaves adentro de tu vehículo? ¡No te estreses! Te mandamos un servicio de cerrajería para que no te quedes varad@.',
    image: cerrajeria,
  },
  {
    title: 'Grúa',
    description:
      '¿Tu vehículo ya no quiso moverse? ¡Ni te agobies! Con tu seguro tienes servicio de grúa cuando lo necesites. ',
    image: grua,
  },
  {
    title: 'Asistencia legal',
    description:
      'Si las cosas se ponen complicadas luego de un accidente, te damos asesoría legal y te acompañamos hasta que el asunto se resuelva.',
    image: legal,
  },
  {
    title: 'Paso de corriente',
    description:
      '¿Tu vehículo se quedó sin batería? Llama a tu seguro para que te pasen corriente y puedas seguir tu camino.',
    image: corriente,
  },
  {
    title: 'Gasolina',
    description:
      '¿Te quedaste sin gasolina y no hay una gasolinera cerca? Tu seguro te rescata y te lleva gasolina hasta donde estés. ¡Ojo! hay cobro por la gasolina.',
    image: gasolina,
  },
  {
    title: 'Traslado médico',
    description:
      'Si por un accidente automovilístico tú o tus acompañantes necesitan ir al hospital, ¡tu seguro te manda una ambulancia!',
    image: ambulancia,
  },
  {
    title: 'Cambio o inflado de llantas',
    description:
      'Si se te ponchó una llanta, tu seguro te echa una mano inflándola o cambiándola por la refacción',
    image: llanta,
  },
];

const Assistances = () => {
  const { breakpoints } = useTheme();
  const isTable = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const gallerySlider = document.getElementById('gallerySliderContainer');
  const sliderTotalWidth =
    (gallerySlider?.scrollWidth || 0) - (gallerySlider?.clientWidth || 0);
  const numberOfCards = cards.length;
  const sectionWidth = sliderTotalWidth / numberOfCards;

  gallerySlider?.addEventListener('scroll', (e) => {
    const scrollLeft = gallerySlider?.scrollLeft;

    cards.forEach((e, i) => {
      if (
        sectionWidth * i <= scrollLeft &&
        scrollLeft <= sectionWidth * (i + 1)
      ) {
        document.getElementById(`indicator-${i}`)?.classList.add('selected');
      } else {
        document.getElementById(`indicator-${i}`)?.classList.remove('selected');
      }
    });
  });

  let pos = { left: 0, x: 0 };

  const mouseMoveHandler = (e: any) => {
    const dx = e.clientX - pos.x;

    if (gallerySlider !== null) {
      gallerySlider.scrollLeft = pos.left - dx;
    }
  };

  const mouseUpHandler = () => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    if (gallerySlider !== null) {
      gallerySlider.style.cursor = 'grab';
      gallerySlider.style.removeProperty('user-select');
    }
  };

  const mouseDownHandler = (e: any) => {
    pos = {
      left: gallerySlider?.scrollLeft || 0,
      x: e.clientX,
    };

    if (gallerySlider !== null) {
      gallerySlider.style.cursor = 'grabbing';
      gallerySlider.style.userSelect = 'none';
    }

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  const handleClickIndicator = (indicatorNumber: number) => {
    if (gallerySlider !== null) {
      if (indicatorNumber + 1 === numberOfCards) {
        gallerySlider.scrollLeft = sliderTotalWidth;
      } else {
        gallerySlider.scrollLeft = indicatorNumber * sectionWidth + 1;
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#F2FAFC',
          paddingTop: '40px',
          paddingRight: 'clamp(40px, 10vw, 120px)',
          paddingBottom: 0,
          paddingLeft: 'clamp(40px, 10vw, 120px)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          component="h2"
          className="section-title"
          style={{
            fontWeight: 700,
            fontSize: isTable ? '22px' : isMobile ? '20px' : '28px',
            lineHeight: '34px',
            textAlign: 'center',
          }}
        >
          ¡Conoce las asistencias extra que te harán sentir aún más seguro,
          seguro!
        </Typography>
        <Typography variant="h5" className="section-subtitle">
          La mayoría de las asistencias de tu seguro de coche son gratis.
          ¡Además son 24/7!
        </Typography>
        <div
          className="gallery-slider-container"
          id="gallerySliderContainer"
          onMouseDown={mouseDownHandler}
        >
          <div className="gallery-slider" id="gallery">
            {cards.map((card, id) => (
              <div key={id} className="card">
                <div className="card-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
                <div className="card-image">
                  <img src={card.image} alt={card.title} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="indicator-slider-container">
          {cards.map((e, i) => (
            <div
              key={i}
              id={`indicator-${i}`}
              className="indicator"
              onClick={() => handleClickIndicator(i)}
            ></div>
          ))}
        </div>
      </Box>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 400,
          paddingLeft: '24px',
          paddingRight: '24px',
          textAlign: 'center',
          paddingBottom: isMobile ? '40px' : '80px',
          backgroundColor: '#F2FAFC',
          paddingTop: '32px',
        }}
      >
        *Los servicios de asistencias pueden variar por tipo de vehículo y
        aseguradora contratada.
      </Typography>
    </>
  );
};

export default Assistances;
